
<template>
  <div class="knd-return">
    <div class="knd-paragraaf">
      <div v-html="tekst"></div>
      
      <div class="" v-if=" $store.getters.totalAnswers === $store.getters.answers.length">
        Goed bezig, je hebt alle vragen beantwoord! Komen morgen terug om de nieuwe vraag van de dag te zien.
      </div>
    </div>

    <div class="knd-btn-container m-b-xl">
      <button class="knd-btn " @click="resetAnswers"> Wis mijn antwoorden en begin opnieuw </button>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex'

export default {
  props: {
    tekst:{
      type: String
    }
  },
  components:{},
  setup() {
    const store = useStore();

    function resetAnswers() {
      store.dispatch('resetAnswers');
    }

    // expose to template and other options API hooks
    return {
      resetAnswers
    }
  }
}
</script>

<style lang="scss">
  .knd-return {
    background: #CBFFE6;
    overflow:hidden;

  }
</style>